import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/fundingColors'

export const useStyles = makeStyles()(() => ({
  breadcrumb: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  link: {
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.mutedText,
  },
  separator: {
    fontSize: 12,
    color: C.mutedText,
  },
  current: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.strongText,
  },
}))
